<template>
  <div class="box2-page">
    <div class="inseec-title">你是否正面临这样的处境？</div>
    <div class="card-box">
      <div class="card-item" v-for="item in list1" :key="item.title">
        <img :src="item.img" alt="" />
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
      </div>
    </div>
    <div class="inseec-title">这些瞬间，是否让你感到无力？</div>
    <div class="card-list">
      <div class="card-item" v-for="item in list2" :key="item.title">
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        list1: [
          {
            img: require("../../../assets/coursePage/inseec/box2/1.png"),
            title: "晋升卡壳的经理人",
            desc: "能力突出，却因“本科/大专”学历，在晋升高管时被拥有MBA的对手轻松超越？",
          },
          {
            img: require("../../../assets/coursePage/inseec/box2/2.png"),
            title: "新晋的管理者",
            desc: "从技术/执行岗转型，缺乏系统商业思维，带团队、做决策时总感觉心里没底？",
          },
          {
            img: require("../../../assets/coursePage/inseec/box2/3.png"),
            title: "学历吃亏的骨干",
            desc: "手下实习生都是硕士，自己学历普通，连开会发言都缺乏底气？",
          },
          {
            img: require("../../../assets/coursePage/inseec/box2/4.png"),
            title: "忙碌的职场实力派",
            desc: "渴望提升，但无法脱产，也被国内动辄数十万的MBA学费劝退？",
          },
        ],
        list2: [
          {
            title: "当汇报方案时",
            desc: "你讲得口干舌燥，却因缺乏“战略框架”包装，被评价为“深度不够”",
          },
          {
            title: "当决策拍板时",
            desc: "因缺少财务与市场数据的支撑，只能凭经验冒险，承担巨大压力",
          },
          {
            title: "当职位空出时",
            desc: "明明业绩最好，却因一纸文凭，被硬性条件拦在门外，与机会失之交臂",
          },
          {
            title: "当团队讨论时",
            desc: "下属满口专业术语和模型，你插不上话，领导权威悄然流失",
          },
        ],
      };
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .box2-page {
    background: #ffffff;
    padding: 80px 40px;
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #012d72;
      line-height: 64px;
      text-align: center;
    }
    .card-box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 22px;
      margin-top: 48px;
      margin-bottom: 80px;
      .card-item {
        background: #f3f5f8;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 100%;
        }
        h4 {
          padding: 4px 16px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          line-height: 40px;
          background: linear-gradient(270deg, #0259ab 0%, #012d72 100%);
          border-radius: 8px;
          margin-top: -44px;
        }
        p {
          font-weight: 400;
          font-size: 26px;
          color: #2f343d;
          line-height: 40px;
          padding: 16px 24px 24px;
        }
      }
    }
    .card-list {
      margin-top: 74px;
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 48px;
      .card-item {
        background: #f3f5f8;
        border-radius: 16px;
        padding: 42px 24px 24px;
        position: relative;
        h4 {
          width: 228px;
          height: 52px;
          background: #053175;
          border-radius: 32px 32px 4px 32px;
          font-weight: 600;
          font-size: 30px;
          color: #ffffff;
          line-height: 44px;
          padding: 4px 0;
          text-align: center;
          box-sizing: border-box;
          position: absolute;
          left: 0;
          top: -26px;
        }
        p {
          font-weight: 400;
          font-size: 26px;
          color: #2f343d;
          line-height: 36px;
        }
      }
    }
  }
</style>
